/**
 * @param {Query} query
 */
export default function SecurityCheck(query) {
  query.addHeader('X-Security-Check', query.securityCheck);
}
